import React, { useEffect, useState } from 'react';
import '../main.css';
import WrappedMap from './Map';
import config from '../../config';
import { apiCall } from '../../../service';
import Error from "../../utils/Error";
import moment from 'moment'

const SpecificData = () => {
  const mapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${process.env.REACT_APP_MAP_KEY}`;
  const [pnrData, setPnrData] = useState("");
  // const [stopId, setStopId] = useState(null);
  const [address, setAddress] = useState('');
  const [arrivalTime, setArrivalTime] = useState('');
  const [vehicleNumber, setVehicleNumber] = useState('');
  const [speed, setSpeed] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("")

  useEffect(() => {
    const url = window.location.href
    const pnr = (url.split('/')[3]).split('?')[0];
    // console.log("pnr url" , pnr)
    // const stopId = url.split('/')[5];
    setPnrData(pnr);
    // setStopId(stopId);

    const fetchData = async () => {
      setError(false);
      setErrorMessage("");
      try {
        const payload = {
          body: {
            pnr: pnr,
            // stopId: stopId,
          },
          method: 'POST',
          host: config.apiEndpoints.userGetVehiclePath.host,
          endPoint: config.apiEndpoints.userGetVehiclePath.url,
        };
        const data = await apiCall(payload);
        console.log("data" , data)
        if (data.status) {
          setLoading(false);
          setAddress(data.address)
          // const etaTime = data.eta.split('T')[1];
          // const [hours, minutes] = etaTime.split(':');
          let end = moment(data.eta)
          let start = moment(new Date())
          let duration = moment.duration(end.diff(start));
          let totalMin = duration.asMinutes()
          let hours =(totalMin / 60).toFixed(0)
          let min  = Math.floor(totalMin%60)
          setArrivalTime(`${hours}hrs ${min}min`);
          // setArrivalTime(data.eta.split('T')[1].split('+')[0])
          setVehicleNumber(data.vehiclePath[0].Vehicle)
          setSpeed(Math.round(data.vehiclePath[data.vehiclePath.length - 1].speed));
        }
        else {
          setError(true)
          setErrorMessage("Trip Hasn't start Yet !!")
          setLoading(false);

          setTimeout(() => {
            setErrorMessage(""); 
            setLoading(true); 
          }, 2000);
        }
      } catch (error) {
        // console.log(speed)
      }
    }
    fetchData();

    const intervalId = setInterval(() => {
      fetchData();
    }, 10000);
    return () => clearInterval(intervalId);
  }, [])

  return (
    <div className="App">
      {
        loading ?
          // <div className='loader_main'>
          //   <div className="loader"></div>
          // </div>
          <div className="loader-wrapper">
            <div className="truck-wrapper">
              <div className="truck">
                <div className="truck-container"></div>
                <div className="glases"></div>
                <div className="bonet"></div>
                <div className="base"></div>
                <div className="base-aux"></div>
                <div className="wheel-back"></div>
                <div className="wheel-front"></div>
                <div className="smoke"></div>
              </div>
            </div>
          </div>
          :
          <div className='user_container'>
            <div className='user_vehicle_location'>
              <>
                {
                  error ? <Error msg={errorMessage} /> :
                    <>
                      <WrappedMap
                        // tripId={tripId}
                        // stopId={stopId}
                        speed={speed}
                        vehicleNo={vehicleNumber}
                        address={address}
                        pnr={pnrData}
                        googleMapURL={mapURL}
                        loadingElement={<div style={{ height: `100%` }} />}
                        containerElement={<div className='mapContainer' />}
                        mapElement={<div style={{ height: `100%` }} />}
                      />
                      <div className='sideTile'>
                        <div>
                          <h3>Vehicle Location</h3>
                          <p><span style={{ color: 'green' }}>Speed: </span> {Math.round(speed)} km/hr</p>
                          <p className='sideTile_content'><span style={{ color: 'green' }}>Arriving In: </span> {arrivalTime}</p>
                          <p className='sideTile_content'><span style={{ color: 'green' }}>Boarding Point: </span> {address}</p>
                          <p className='sideTile_content'><span style={{ color: 'green' }}>Vehicle No: </span> {vehicleNumber}</p>
                        </div>
                      </div>
                    </>
                }
              </>
            </div>
          </div>
      }
    </div>
  );
}

export default SpecificData;